// No-op notifee functions for web platform

/* eslint-disable @typescript-eslint/no-unused-vars */

// Mock enum values for web
export enum EventType {
  PRESS = 1,
}

export enum AndroidImportance {
  HIGH = 4,
}

export enum AndroidStyle {
  BIGTEXT = 1,
}

export const createChannel = async (channelConfig: {
  id: string
  name: string
  vibration?: boolean
  importance?: AndroidImportance
}) => {
  // No-op for web
  console.log('notifee.createChannel for web - no-op', channelConfig.id)
  return channelConfig.id
}

export const displayNotification = async (notificationConfig: {
  android?: {
    channelId: string
    color?: string
    style?: {
      text?: string
      type?: AndroidStyle
    }
  }
  body?: string
  title?: string
  data?: any
}) => {
  // No-op for web
  console.log(
    'notifee.displayNotification for web - no-op',
    notificationConfig.title,
  )
  return Promise.resolve()
}

export const onForegroundEvent = (
  listener: (event: { type: EventType; detail: any }) => void,
) => {
  // No-op for web
  console.log('notifee.onForegroundEvent for web - no-op')
  return () => {} // Return unsubscribe function
}

export const setBadgeCount = (count: number) => {
  // No-op for web
  console.log('notifee.setBadgeCount for web - no-op', count)
  return Promise.resolve()
}
